export default "__VITE_ASSET__gGZ2qgYL__"